module.exports = __webpack_public_path__ + "img/fontcontrol_cn.323c676.jpg";